import BrandInfoContainer from './containers/BrandInfoContainer';

export default BrandInfoContainer;
